export const VALIDATE_BUTTON_BG = "#1D3BE6";
export const VALIDATE_BUTTON_BG_PRESSED = "#080F6B";
export const FONT_FAMILY = "Helvetica";
export const BODY1_FONT_SIZE = "14px";
export const BODY1_FONT_WEIGHT = 400;
export const BODY1_LINE_HEIGHT = "21px";
